module.exports = __webpack_public_path__ + "static/desktop-submersible-pump-14b21cd2353e594aa10cafd5dbb30b63.jpg";